var notEmpty = function (_a) {
  var _b = _a === void 0 ? {
    message: 'Обязательное поле'
  } : _a,
      message = _b.message;

  return function (value) {
    if (typeof value !== 'number' && !value) {
      return message;
    }

    if (typeof value === 'string' && value.trim().length === 0) {
      return message;
    }

    return;
  };
};

export default notEmpty;
export { notEmpty };
